import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaCheckCircle, FaBullseye, FaUsers } from 'react-icons/fa';
import fundo3 from '../../img/fundo3.png'
import p from '../../img/p.png'
import './NossoTeam.css'

const NossoTeam = () => {
  return (
    <div className="section">
      <div className="block">
      <div className="content">
      </div>
    </div>




      {/* Segundo Bloco */}
      <Container className="my-5">
        <Row>
          <Col>
            <h2 style={{color:'#ff5722'}}>Conheça nossa história</h2>
            <p>Nossa jornada começou com um compromisso poderoso: oferecer soluções integradas de qualidade para as necessidades de nossos clientes.Com profissionais especializados nas áreas de manutenção predial, tecnologias de informação e consultoria, o objetivo é proporcionar serviços completos, eficientes e inovadores.

Desde o início, nossa missão foi transformar a forma como nossos clientes lidam com seus ativos prediais e tecnológicos, sempre com um foco claro em resultados sustentáveis e atendimento personalizado. Acreditamos que cada cliente é único, e é por isso que buscamos sempre entender suas necessidades específicas, oferecendo soluções sob medida.
              </p></Col>
        </Row>
      </Container>

      {/* Terceiro Bloco */}
      <Container className="my-5">
        <Row>
          <Col md={6}>
            <img src={fundo3} alt="Imagem" className="img-fluid" />
          </Col>
          <Col md={6}>
            <Row>
              <Col>
                <div className="text-center">
                  <FaCheckCircle size={50} color='#ff5722' />
                  <h4>Visão</h4>
              

                  </div>
                  <p>Posicionar-se como uma empresa de referência de vendas de produtos e serviços a 
                  nível nacional</p>
                
              </Col>
              <Col>
                <div className="text-center">
                  <FaBullseye size={50} color='#ff5722' />
                  <h4>Missão</h4>
          

                  </div>
                  <p>Oferecer vantagens competitivas, alinhadas ao Plano Estratégico dos nossos 
Clientes/Parceiros com a finalidade de ajudá-los a atingir os seus objectivos, oferecendo 
sempre soluções inteligentes, económicas e inovadoras a fim de acrescentar valor 
ao negócio</p>
            
              </Col>
              <Col>
                <div className="text-center">
                  <FaUsers size={50} color='#ff5722' />
                  <h4>Valores</h4>
                  </div>
                  <div>
                    <p>Gratidão e Valorização: Somos gratos pelas parcerias de negócios que efectivamos e 
valorizamos parceiros que contribuem para o nosso engrandecimento.
</p>
<p>
Confiança: Privilegiamos a segurança acima de tudo.
</p>
<p>
Qualidade e segurança: Primamos pela qualidade em tudo o que fazemos e 
privilegiamos a segurança acima de tudo
</p>
                  </div>
                 
                
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>


     
    </div>
  );
}

export default NossoTeam;
